import React from 'react';

import MakkahImg from '../../assets/services/makkah.jpg';
import MadinahImg from '../../assets/services/madinah.jpg';

const Services = () => {
    return (
        <div className='w-[80vw] h-full flex flex-col justify-center items-center gap-5'>
            <div className="px-2 lg:px-0 w-full h-[10%] lg:h-[15%] flex flex-col justify-center items-center gap-5">
                <h1 className="text-2xl md:text-3xl lg:text-5xl font-bold text-black text-center">
                    OUR SERVICES
                </h1>
                <p className="text-md: md:text-md lg:text-xl text-gray-500 font-semibold text-center">
                    Choose from our selection of high-end, latest models of Vans from some of the world's top luxury car manufacturers.
                </p>
            </div>
            <div className='w-full h-[30%] lg:h-[40%] flex flex-col lg:flex-row justify-center items-center overflow-hidden gap-5'>
                <img
                    src={MakkahImg}
                    alt="makkah_img"
                    className="w-full h-full object-cover rounded-3xl"
                />
                <img
                    src={MadinahImg}
                    alt="madinah_img"
                    className="w-full h-full object-cover rounded-3xl"
                />
            </div>
            <div className="w-full h-[60%] lg:h-[55%] flex justify-center items-center">
                <p className="text-center text-gray-800 leading-relaxed max-w-3xl">
                    At our luxury van service, we aim to provide unparalleled comfort, convenience, and professionalism for your travels in the holy city of Madinah. Whether you are visiting for spiritual purposes or sightseeing, we cater to your specific needs with our premium services:
                    <br /><br />
                    <strong>Pick-ups and Drop-offs</strong><br />
                    <ul className="mt-2">
                        <li><strong>Hotels</strong> Convenient transfers to and from your accommodation in Madinah.</li>
                        <li><strong>Masjid an-Nabawi</strong> Direct transportation to and from the Prophet’s Mosque, ensuring a stress-free and timely visit.</li>
                        <li><strong>Madinah Airport</strong> Seamless pick-ups and drop-offs to Madinah’s airport, providing comfort right from your arrival.</li>
                    </ul>
                    <br />
                    <strong>Guided Full-Day Tours</strong><br />
                    Immerse yourself in the spiritual and historical significance of Madinah with a guided tour that includes:
                    <br />
                    <ul className="mt-2">
                        <li><strong>Masjid Quba</strong> Visit the first mosque built in Islam, a place of immense spiritual importance.</li>
                        <li><strong>Masjid Qiblatain</strong> Witness the mosque where the Qiblah (direction of prayer) was divinely changed.</li>
                        <li><strong>Madinah Museum</strong> Explore the life and times of the Prophet Muhammad (صلى الله عليه وسلم) through artifacts and exhibits, including the blessed Hijrah journey.</li>
                        <li>Other famous landmarks that bring the rich history of Madinah to life.</li>
                    </ul>
                    <br />
                    Our service is designed to enhance your experience, whether you're visiting Masjid an-Nabawi for prayer, exploring the city’s landmarks, or learning about the profound legacy of Islam in Madinah.
                </p>
            </div>
        </div>
    )
}

export default Services;
